// extracted by mini-css-extract-plugin
export default {"bindingTime":"styles_bindingTime__-8qb+","chip":"styles_chip__m5MBP","terminatedChip":"styles_terminatedChip__jmuFh","divider":"styles_divider__1OMXC"};